import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BirthDayList } from 'src/app/admin/models/birthdaylistmodel';
import { BirthdayListService } from 'src/app/admin/services/birthday-list.service';

@Component({
  selector: 'app-birthday-delete-modal',
  templateUrl: './birthday-delete-modal.component.html',
  styleUrls: ['./birthday-delete-modal.component.scss'],
})
export class BirthdayDeleteModalComponent implements OnInit {
@Input() birthdayListList!: BirthDayList; 
currentPage: number = 1;
  itemsPerPage: number = 10
  cityQuery: string = ''
  roomNameQuery: string = '';
  birthdayZoneNameQuery: string = '';
  VisitorNameQuery: string = ''; 
  CallDateFromQuery: string = '';
  CallDateToQuery: string = '';
  AppointmentDateFromQuery: string = '';
  AppointmentDateToQuery: string = '';
  PricePerChildrenFromQuery:string=''
  PricePerChildrenToQuery: string=''
  PlannedChildNumberFromQuery: string = '';
  PlannedChildNumberToQuery: string = '';
  PresentChildNumberQuery: string = '';
  PresentChildNumberFromQuery: string = '';
  PresentChildNumberToQuery: string = '';
  TotalPricePaidQuery: string = '';
  TotalPricePaidFromQuery: string = '';
  TotalPricePaidToQuery: string = '';
  StatusCallQuery: string = '';
   NumberOfBirthdayFromQuery:string=''
  NumberOfBirthdayToQuery: string=''
  AdvancePaymentWillQuery:string=''
   AdvancePricePaidFromQuery:string=''
  AdvancePricePaidToQuery:string=''

  constructor(private modalController: ModalController,private birthdayListService: BirthdayListService,) { }

  ngOnInit() {
this.StatusCallQuery = '0'
  }

removeBirthDay(){
 this.StatusCallQuery = '0'
  this.birthdayListService.deleteBirthday(this.birthdayListList.id).subscribe(res => {
       this.birthdayListService.getAllBirthday({
          currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
          cityQuery: this.cityQuery,
          roomNameQuery: this.roomNameQuery,
          birthdayZoneNameQuery: this.birthdayZoneNameQuery,
          VisitorNameQuery: this.VisitorNameQuery,          
          CallDateFromQuery: this.CallDateFromQuery,
          CallDateToQuery: this.CallDateToQuery,
          AppointmentDateFromQuery: this.AppointmentDateFromQuery,
          AppointmentDateToQuery: this.AppointmentDateToQuery,          
          PricePerChildrenFromQuery:this. PricePerChildrenFromQuery,   
          PricePerChildrenToQuery: this.PricePerChildrenToQuery,     
          PlannedChildNumberFromQuery: this.PlannedChildNumberFromQuery,
          PlannedChildNumberToQuery: this.PlannedChildNumberToQuery,
          PresentChildNumberFromQuery: this.PresentChildNumberFromQuery,
          PresentChildNumberToQuery: this.PresentChildNumberToQuery,
          TotalPricePaidFromQuery: this.TotalPricePaidFromQuery,
          TotalPricePaidToQuery: this.TotalPricePaidToQuery,
          StatusCallQuery: this.StatusCallQuery,
           NumberOfBirthdayFromQuery:this.NumberOfBirthdayFromQuery,
          NumberOfBirthdayToQuery:this.NumberOfBirthdayToQuery,
          AdvancePaymentWillQuery:this.AdvancePaymentWillQuery,
          AdvancePricePaidFromQuery:this.AdvancePricePaidFromQuery,
          AdvancePricePaidToQuery:this.AdvancePricePaidToQuery

        })
      this.dismissModal();
    },(err) => {
      console.error(err);
    })


}
dismissModal() {
    this.modalController.dismiss();
  }

}
